import { SvgIcon, SvgIconProps } from '@mui/material';

function TotalSessionsSVG(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.6584 10.369H16.0468L9.65058 19.6272L10.831 14.2379L10.964 13.631H10.3426H6.95316L13.3499 4.37209L12.17 9.76212L12.0372 10.369H12.6584Z"
        stroke="#0173C8"
      />
    </SvgIcon>
  );
}

export default TotalSessionsSVG;
